import { render, staticRenderFns } from "./ot-documents-layout.vue?vue&type=template&id=8b94b814&scoped=true&"
import script from "./ot-documents-layout.vue?vue&type=script&lang=ts&"
export * from "./ot-documents-layout.vue?vue&type=script&lang=ts&"
import style0 from "./ot-documents-layout.vue?vue&type=style&index=0&id=8b94b814&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b94b814",
  null
  
)

export default component.exports